import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "manager-requests__filter-bar" }

import { ref, watch } from 'vue';
import Select from 'primevue/select';
import type { RequestStatus } from '../types';

interface StatusOption {
  label: string;
  value: RequestStatus | '';
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusFilterSimple',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const statusOptions: StatusOption[] = [
  { label: 'Все статусы', value: '' },
  { label: 'Новая', value: 'Новая' },
  { label: 'В работе', value: 'В работе' },
  { label: 'Требуется информация', value: 'Требуется информация' },
  { label: 'Отклонена', value: 'Отклонена' },
  { label: 'Исполнена', value: 'Исполнена' },
];

const localValue = ref<RequestStatus | ''>(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => {
    localValue.value = newVal;
  },
);

function onUpdate(value: RequestStatus | ''): void {
  emit('update:modelValue', value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("label", {
      for: "status-filter",
      class: "manager-requests__filter-bar-label"
    }, "Фильтр по статусу:", -1)),
    _createVNode(_unref(Select), {
      id: "status-filter",
      modelValue: localValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
        onUpdate
      ],
      options: statusOptions,
      optionLabel: "label",
      optionValue: "value",
      placeholder: "Все статусы"
    }, null, 8, ["modelValue"])
  ]))
}
}

})